import { render, staticRenderFns } from "./activityLimitTimePrice.vue?vue&type=template&id=c1a47ed4&"
import script from "./activityLimitTimePrice.vue?vue&type=script&lang=js&"
export * from "./activityLimitTimePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports